import React from 'react';
import { motion } from 'framer-motion';
export function InstructorSection() {
  return <section className="py-24 bg-gradient-to-b from-[#1A0230] to-[#0D0118] relative px-4 sm:px-6 lg:px-8" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-108">
          {/* Instructor Image */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2 relative" data-id="element-109">
            <div className="relative aspect-square max-w-md mx-auto rounded-full overflow-hidden border-4 border-[#FF2D8A]/30 shadow-[0_0_50px_rgba(255,45,138,0.2)]" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/pDrrvy2FaEZfJ3DAiVhv7U/freepik__ultradetailed-studio-portrait-of-a-young-woman-wit__77538.png" alt="Catalina Ferreyra" className="w-full h-full object-cover object-center" data-id="element-111" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D0118] via-transparent to-transparent opacity-40" data-id="element-112"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute bottom-10 right-0 md:-right-10 bg-white/10 backdrop-blur-md border border-white/20 p-4 rounded-2xl shadow-xl" data-id="element-113">
              <p className="text-white font-bold text-lg" data-id="element-114">Más de 10.000</p>
              <p className="text-[#FF2D8A] text-sm font-semibold" data-id="element-115">
                Alumnas transformadas
              </p>
            </div>
          </motion.div>

          {/* Instructor Bio */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2" data-id="element-116">
            <h2 className="text-sm font-bold text-[#FF2D8A] tracking-widest uppercase mb-2" data-id="element-117">
              CONOCÉ A TU INSTRUCTORA
            </h2>
            <h3 className="text-4xl sm:text-5xl font-black text-white mb-6" data-id="element-118">
              Catalina Ferreyra
            </h3>

            <div className="space-y-6 text-lg text-gray-300" data-id="element-119">
              <p data-id="element-120">
                Especialista en relaciones íntimas y sexualidad femenina, ayudé
                a miles de mujeres a transformar su vida íntima, recuperar la
                confianza y disfrutar del placer sin vergüenza ni tabúes.
              </p>
              <p data-id="element-121">
                Creadora de múltiples programas digitales exitosos, mi enfoque
                se basa en la educación práctica, directa y sin rodeos. Mi
                misión es que cada mujer se sienta segura, poderosa e
                irresistible en la intimidad.
              </p>
              <p className="font-medium text-white border-l-4 border-[#FFD700] pl-4 italic" data-id="element-122">
                "El placer no es un lujo, es un derecho. Y aprender a darlo y
                recibirlo es el acto de amor propio más grande que existe."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}